<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-sm-h6">
					<span class="primary--text text-uppercase font-weight-bold"><v-icon color="primary">mdi-message-plus-outline</v-icon> Buat Pesan Baru</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row align="center" justify="center">
						<v-col cols="12" class="pt-0 pb-1">
							<div class="text-body-2 font-weight-bold mb-4">Untuk memulai percakapan, Silakan masukkan nama Referral Toko terlebih dahulu.</div>
							<v-row>
								<v-col cols="12" class="mt-n5 pb-2 pr-1">
									<v-text-field v-model="referralId" :rules="referralRules" :error-messages="fieldErrors" outlined dense class="rounded-lg text-body-2" hide-details="auto" validate-on-blur></v-text-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-col cols="12" class="py-2 text-center">
						<v-btn @click="actSetStore" :loading="loading" :disabled="(referralId == '') ? true : false" depressed color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg">Submit</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
			dialog: false,
			referralId: '',
			listStores: [],
			detailStore: {},
			loading: false,
			fieldErrors: null,
			referralRules: [
        v => !!v || 'Toko wajib dipilih terlebih dahulu'
      ],
		}
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		actSetStore() {
			this.getStoreDetail()
		},
		async getStoreDetail() {
			this.loading = await true
			await this.$http
				.get(`/store/detail-store/${this.referralId}`)
				.then((res) => {
					const data = res.data.data
					this.detailStore = data
					if (Object.keys(data).length > 0) localStorage.setItem('HwiEcomStore', this.referralId)

					setTimeout(() => {
						this.loading = false
						this.fieldErrors = null
						location.reload()
					}, 600);
				})
				.catch((error) => {
					// console.log(error.response.data.message)
					this.fieldErrors = error.response.data.message
					this.loading = false
				})
		},

		getStoreList() {
			this.$http
				.get(`/store/list-store`)
				.then((res) => {
					const data = res.data.data
					this.listStores = data.results
				})
				.catch((error) => {
					// console.log(error.response.data.message)
					this.fieldErrors = error.response.data.message
					this.loading = false
				})
		},
		
		customFilter (item, queryText) {
			const keywords = item.store_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return keywords.indexOf(searchText) > -1
		}
	},

	mounted() {
		this.getStoreList()
	},
};
</script>